var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNrgLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1080_183726)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#00E676"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0026 3.80005L17 8.86449L12.0004 13.9259L10.0002 11.9013L13.0002 8.86449L12.0004 7.85199L8.00009 11.9013L12.0004 15.9507L18.0002 9.87651L20 11.9013L12.0004 20L4 11.9013L12.0026 3.80005Z",
    fill: "#141619"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 23.5999C18.4064 23.5999 23.5999 18.4064 23.5999 11.9999C23.5999 5.5934 18.4064 0.399902 11.9999 0.399902C5.5934 0.399902 0.399902 5.5934 0.399902 11.9999C0.399902 18.4064 5.5934 23.5999 11.9999 23.5999Z",
    stroke: "#00E676"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1080_183726"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNrgLogoDark);
export default __webpack_public_path__ + "static/media/NRGLogoDark.b971bbaf9e6d64024cf49ecdb10f79ae.svg";
export { ForwardRef as ReactComponent };